import React, {createContext, useReducer} from 'react';
import Layout from '../Shared/Layout';
import {Container} from "@material-ui/core";
import styled from "styled-components";
import FormPage from "../Shared/FormPage";
import BackButton from "../Shared/BackButton";
import {DynamicColorPreset} from "../Shared/DynamicColorPreset";
import { Trans } from "../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";
import WarningIcon from '@material-ui/icons/Warning';
import CheckIcon from '@material-ui/icons/Check';

const Wrapper = styled.div`
`;

export default function ReturnServiceCancel({ message, success }) {
    return (
        <Wrapper>
            <Container maxWidth="md">
                <h1>
                    <Trans i18nKey="returnservice.form.pickup-cancel">Cancel Pickup</Trans></h1>
                    <p>
                        {
                            success && <CheckIcon/>
                        }
                        {
                            !success && <WarningIcon/>
                        }
                        &nbsp;&nbsp;
                        { message }
                    </p>
            </Container>
        </Wrapper>
    )
}


ReturnServiceCancel.layout = page => <Layout children={page} />;
